export const inputSx = {
  '&:hover': { borderColor: 'primary.500' },
  '&:focus-within': { borderColor: 'primary.500' }
};

export const submitButtonSx = {
  backgroundColor: 'primary.500',
  '&:hover': { backgroundColor: 'primary.600' }
};

export const stockModalSx = {
  width: '80%',
  maxWidth: '80%',
  maxHeight: '90vh',
  overflowY: 'auto'
};

export const EXPIRY_SHORTCUTS = [
  { label: '3 months', months: 3 },
  { label: '6 months', months: 6 },
  { label: '1 year', years: 1 },
  { label: '2 years', years: 2 },
  { label: '3 years', years: 3 }
];

export const YEAR_END_SHORTCUTS = [
  { label: '1 year', years: 1 },
  { label: '2 year', years: 2 },
  { label: '3 year', years: 3 }
];

export const calcExpiryFromBaseDate = (baseDate, { months = 0, years = 0 } = {}) => {
  if (!baseDate) return '';
  const d = new Date(`${baseDate}T12:00:00`);
  if (Number.isNaN(d.getTime())) return '';
  if (months) d.setMonth(d.getMonth() + months);
  if (years) d.setFullYear(d.getFullYear() + years);
  return d.toISOString().slice(0, 10);
};
